import { Controller } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import Select from 'components/UI/Inputs/Select';
import { PriceProposalStatus } from 'src/db/entities/proposal/ProposalEntity';

import styles from './statusSelect.module.scss';

const StatusSelect = ({
                        control, name= 'status', defaultValue = PriceProposalStatus.DRAFT, }) => {
  const { t } = useTranslation('proposal-form');
  const options = [
    {
      value: PriceProposalStatus.DRAFT,
      text: t(`form.field.status_value.${PriceProposalStatus.DRAFT}`),
    },
    {
      value: PriceProposalStatus.SENT,
      text: t(`form.field.status_value.${PriceProposalStatus.SENT}`),
    },
    {
      value: PriceProposalStatus.ACCEPTED,
      text: t(`form.field.status_value.${PriceProposalStatus.ACCEPTED}`),
    },
    {
      value: PriceProposalStatus.REJECTED,
      text: t(`form.field.status_value.${PriceProposalStatus.REJECTED}`),
    },
    {
      value: PriceProposalStatus.EXPIRED,
      text: t(`form.field.status_value.${PriceProposalStatus.EXPIRED}`),
    }
  ];

  return (
      <div className={styles.wrapper}>
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field }) => (
                <Select
                    {...field}
                    options={options}
                    fullWidth
                    className={styles.select}
                />
            )}
        />
      </div>
  );
};

export default StatusSelect;
